import React from 'react';
import { useAuth, AuthProvider } from './contexts/authContext';
import { useRoutes } from 'react-router-dom';
import router from './router';
import { CssBaseline } from '@mui/material';
import Loader from './components/ProgressBars/BladeLoader';
import theme from './styles/Themes/Theme'
import { ThemeProvider } from "@mui/material";
import { ThemeProvider as ThemeProviderLegacy } from "@mui/styles";
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();

const AppContent = () => {
  const { loading } = useAuth();
  const routes = useRoutes(router);

  if (loading) {
    return <Loader />
  }

  return routes;
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <ThemeProviderLegacy theme={theme}>
        <AuthProvider>
          <CssBaseline enableColorScheme />
          <QueryClientProvider client={queryClient}>
            <AppContent />
          </QueryClientProvider>
        </AuthProvider>
      </ThemeProviderLegacy>
    </ThemeProvider>
  );
};

export default App;

